export const primaryColor = '#C3073F';
export const primaryDarkColor = '#1A1A1D';

export const successColor = '#0197F6';
export const infoColor = '#0197F6';
export const errorColor = '#F2AF29';
export const warningColor = '#F2AF29';

export const CAMPO_INFORMACAO = '#ecf2f2';//'papayawhip';
export const CAMPO_CABECALHO = '#ecf2f2';//'papayawhip';

//Utilizar aparti de 08/03/2021


export const CAMPO_INFORMACAO_BACKGROUND = '#ecf2f2';//'papayawhip';
export const CAMPO_INFORMACAO_TEXTO = '#252525';

export const CAMPO_DETALHE_INFORMACAO = 'blueviolet';
export const CAMPO_DETALHE_INFORMACAO_1 = '#ecf2f2';//'papayawhip';